import { render, staticRenderFns } from "./VolunteerProfileEditBackground.vue?vue&type=template&id=54a8c48e&scoped=true"
import script from "./VolunteerProfileEditBackground.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileEditBackground.vue?vue&type=script&lang=js"
import style0 from "./VolunteerProfileEditBackground.vue?vue&type=style&index=0&id=54a8c48e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8c48e",
  null
  
)

export default component.exports